module.exports = __webpack_public_path__ + "img/AMD.OQ.26846bb7.png";